import {createRouter, createWebHistory} from 'vue-router'
import ProfileView from '../views/ProfileView.vue'
import caseView from '../views/caseView.vue'
import notfoundView from '../views/notfoundView.vue'
import passResetView from '../views/passResetView.vue'
import IframeView from '../views/IframeView.vue'

const routes = [
    {
        path: '/',
        name: 'profile',
        component: ProfileView,
        meta: {
            title: 'SAFE App',
            site_url: 'https://safeapp.myamh.org',
            favicon: '/img/icons/favicon.ico'
        },
        props: true
    },
    {
        path: '/caseview/:caseid/:fetchCaseDetailsFrom/:partnerId/:caseYear',
        name: 'case',
        component: caseView,
        meta: {
            title: 'SAFE App',
            site_url: 'https://safeapp.myamh.org',
            favicon: '/img/icons/favicon.ico'
        },
        props: true
    },
    {
        path: '/passwordreset/:passToken/',
        name: 'passwordreset',
        meta: {
            title: 'SAFE App',
            site_url: 'https://safeapp.myamh.org',
            favicon: '/img/icons/favicon.ico'
        },
        component: passResetView,
        props: true
    },
    {
        path: '/docs',
        name: 'documentation',
        component: IframeView,
        meta: {
            url: 'https://safedocs.myamh.org',
            title: 'SAFE App | Docs',
            site_url: 'https://safeapp.myamh.org',
            favicon: '/img/icons/favicon.ico'
        },
        beforeEnter() {
            const storedAccount = localStorage.getItem("account");
            if (!storedAccount) {
                return '/'
            }
        },
        props: true
    },
    {
        path: "/:catchAll(.*)",
        name: 'notfound',
        component: notfoundView,
        meta: {
            title: 'SAFE App',
            site_url: 'https://safeapp.myamh.org',
            favicon: '/img/icons/favicon.ico'
        },
        props: true
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.afterEach((to) => {
    document.title = to.meta.title || 'SAFE App'
    document.site_url = to.meta.site_url || 'https://safeapp.myamh.org'

    const favicon = document.querySelector('link[rel="icon"]')
    if (favicon) {
        favicon.href = to.meta.favicon || '/img/icons/favicon.ico'
    }
})

export default router
